import React, {Component, Fragment} from 'react';
import RoomListItem from '../../components/RoomListItem/RoomListItem';
import axios from 'axios';

class RoomList extends Component {

    constructor(props) {
        super(props);
        document.title = 'Room list';
    }

    state = {
        rooms: []
    };

    componentDidMount() {
        axios.get('/api/rooms')
            .then(response => {
                console.log("room list: ", response.data);
                this.setState({
                        rooms: response.data
                    }
                );
            });
    }

    deleteRoomHandler = (id) => {
        axios.delete('/api/rooms/' + id)
            .then(response => {
                console.log(response);
                this.componentDidMount();
            })
            .catch(error => {
                console.warn(error.response);
            });
    }


    render() {

        const rooms = this.state.rooms.map(room => {
            return <RoomListItem
                key={room.id}
                hotelName={room.hotelName}
                hotelId={room.hotelId}
                id={room.id}
                name={room.name}
                imageUrl={room.imageUrl}
                numberOfBeds={room.numberOfBeds}
                pricePerNight={room.pricePerNight}
                deleteHandler={this.deleteRoomHandler}
            />
        });

        const bgStyle = {
            height: "50vh",
            backgroundImage: "url('../assets/img/city-profile.jpg')",
            marginTop: "-20px",
            backgroundPosition: "top center"

        };
        return (

            <Fragment>
                <div className="page-header header-filter align-content-lg-center" data-parallax="true"
                     style={bgStyle}>
                    <div className="container">
                        <h1 className="card-title text-light">Rooms</h1>
                        <br/>
                        <br/>
                        <br/>

                    </div>
                </div>
                <div className="main main-raised">
                    <div className="profile-content">
                        <div className="container">
                            <div className="row">

                                {rooms}

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>


        )

    }
}


export default RoomList;


// WEBPACK FOOTER //
// ./src/containers/RoomList/RoomList.jsx